<template>
  <div class="p-2">
    <SwdSubHeader class="px-1" title="" :bread-crumbs-data="breadCrumbsData" />
  </div>
  <div class="border-b border-color-grey flex h-14">
    <router-link :to="{ name: 'profile' }">
      <div class="p-5 text-sm text-main cursor-pointer" :class="{ active: getActiveTab === 'profile' }">
        Profile Settings
      </div>
    </router-link>

    <!-- <router-link v-if="$can('advisor', 'all')" :to="{ name: 'information' }">
      <div class="p-5 text-sm text-main cursor-pointer" :class="{ active: getActiveTab === 'information' }">
        Information
      </div>
    </router-link> -->

    <!-- <router-link v-if="$can('advisor', 'all')" :to="{ name: 'partners' }">
      <div class="p-5 text-sm text-main cursor-pointer" :class="{ active: getActiveTab === 'partners' }">Partners</div>
    </router-link> -->

    <router-link :to="{ name: 'settings' }">
      <div class="p-5 text-sm text-main cursor-pointer" :class="{ active: getActiveTab === 'settings' }">Settings</div>
    </router-link>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import ROLE from '../../enums/roles'

export default {
  name: 'SettingsHeader',
  setup() {
    const route = useRoute()
    const store = useStore()
    const memberId = store.state.globalComponents?.memberId
    const getType = () => {
      return store.state.globalComponents.role
    }

    const getActiveTab = computed(() => {
      return route.name
    })

    const breadCrumbsData = computed(() => {
      if (getType() === ROLE.CLIENT) {
        return [
          {
            title: 'Dashboard',
            to: `/${getType()}/member/${memberId}/member-details`,
          },
          route.name === 'profile'
            ? {
                title: 'Profile Settings',
                to: `/${route.meta?.type}/settings-app/profile`,
              }
            : {
                title: 'Settings',
                to: `/${route.meta?.type}/settings-app/settings`,
              },
        ]
      } else {
        return [
          {
            title: 'Dashboard',
            to: `/${getType()}/dashboard`,
          },
          route.name === 'profile'
            ? {
                title: 'Profile Settings',
                to: `/${route.meta?.type}/settings-app/profile`,
              }
            : {
                title: 'Settings',
                to: `/${route.meta?.type}/settings-app/settings`,
              },
        ]
      }
    })

    return {
      getActiveTab,
      breadCrumbsData,
    }
  },
}
</script>

<style scoped>
.active {
  border-bottom: 3px solid #83ccf0;
  color: #83ccf0;
  height: 57px;
}
</style>
